// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__Krm8d","active":"Sidebar_active__NtAiM","linksStroke":"Sidebar_linksStroke__A2MfQ"};